import React from "react";
import PropTypes from "prop-types";
import styles from "./CompleteAccountCreation.module.scss";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Button from "@material-ui/core/Button";
import RArrow from "../../../../assets/img/arrow_r_small.png";
import api from "../../../../services/Api";
import { Alert } from "@material-ui/lab";
import SuccessIcon from "../../../../assets/img/success.png";
import ErrorIcon from "../../../../assets/img/error.png";

class CompleteAccountCreation extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      pw1Err: null,
      pw2Err: null,
      password: null,
      password2: null,
      error: null,
      minLength: false,
      minOneSmallLetter: false,
      minOneBigLetter: false,
      minOneNumber: false,
    };
  }

  ShowPassword = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  changeField = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });

    switch (event.target.name) {
      case "password": {
        this.setState({
          pw1Err: event.target.value ? null : "Wprowadź hasło!",
          minLength: event.target.value.length >= 8,
          minOneSmallLetter: /[a-z]/.test(event.target.value),
          minOneBigLetter: /[A-Z]/.test(event.target.value),
          minOneNumber: /[0-9]/.test(event.target.value),
        });
        break;
      }
      case "password2": {
        this.setState({
          pw2Err: event.target.value
            ? event.target.value === this.state.password
              ? null
              : "Wprowadzone hasła nie są takie same!"
            : "Wprowadź ponownie hasło!",
        });
        break;
      }
    }
  };

  assignPassword = () => {
    let self = this;

    api
      .post("users", {
        email: this.props.email,
        password: this.state.password,
        mobile: this.props.phone,
        role: "customer",
      })
      .then((response) => {
        if (response.data.success === true) {
          this.props.setUserId(response.data.data.id);

          api
            .put("clients/mergeUser/" + this.props.clientId, {
              id: response.data.data.id,
            })
            .then((response) => {
              if (response.data.success === true) {
                this.props.createAppointmentRef(true);
                this.props.changeStep("next");
              }
            });
        }
      })
      .catch(function (error) {
        if (error.response) {
          self.setState({
            error: error.response.data.error,
          });
        }
      });
  };

  render() {
    const { showPassword, password, password2, pw1Err, pw2Err } = this.state;
    const { email } = this.props;

    const alreadyExistText = (
      <div>
        Podany adres e-mail jest już zajęty.
        <span
          onClick={() => {
            this.props.changeStep(
              "prev",
              true,
              this.state.error === "User already exists"
            );
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
        >
          {" "}
          Zmień e-mail.
        </span>
      </div>
    );

    return (
      <div className={styles.CompleteAccountCreation}>
        <h2 className={styles.title}>
          <strong>Aby zapłacić</strong>, zarejestruj konto.
        </h2>

        <form className={styles.login_form} onSubmit={this.onFormSubmit}>
          <FormControl>
            <div className={styles.changeEmailRow}>
              <span>{email}</span>
              <div
                onClick={() => {
                  this.props.changeStep(
                    "prev",
                    true,
                    this.state.error === "User already exists"
                  );
                }}
                className={styles.changeNumber}
              >
                Zmień e-mail <img src={RArrow} alt="right arrow" />
              </div>
            </div>
            <hr />
            <label>
              Hasło <span className={styles.reqStar}>*</span>
            </label>
            <TextField
              error={pw1Err}
              helperText={pw1Err}
              onChange={this.changeField}
              variant="outlined"
              size="small"
              type={showPassword ? "text" : "password"}
              className={styles.input_cont}
              InputProps={{
                className: styles.input,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Show password"
                      className={styles.show_password}
                      onClick={this.ShowPassword}
                      tabIndex="-1"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              name="password"
            />
          </FormControl>

          <FormControl>
            <label>
              Powtórz hasło <span className={styles.reqStar}>*</span>
            </label>

            <TextField
              error={pw2Err}
              helperText={pw2Err}
              onChange={this.changeField}
              variant="outlined"
              size="small"
              type={showPassword ? "text" : "password"}
              className={styles.input_cont}
              InputProps={{
                className: styles.input,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Show password"
                      className={styles.show_password}
                      onClick={this.ShowPassword}
                      tabIndex="-1"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              name="password2"
            />
          </FormControl>
          <div className={styles.requirements}>
            <div className={styles.single}>
              <img
                src={
                  this.state.password &&
                  this.state.password === this.state.password2
                    ? SuccessIcon
                    : ErrorIcon
                }
                alt="Icon"
              />
              <span>Hasła muszą być takie same.</span>
            </div>

            <div className={styles.single}>
              <img
                src={this.state.minLength ? SuccessIcon : ErrorIcon}
                alt="Icon"
              />
              <span>Hasło musi zawierać przynajmniej 8 znaków.</span>
            </div>

            <div className={styles.single}>
              <img
                src={this.state.minOneSmallLetter ? SuccessIcon : ErrorIcon}
                alt="Icon"
              />
              <span>Hasło musi zawierać przynajmniej jedną małą literę</span>
            </div>

            <div className={styles.single}>
              <img
                src={this.state.minOneNumber ? SuccessIcon : ErrorIcon}
                alt="Icon"
              />
              <span>Hasło musi zawierać przynajmniej jedną cyfrę</span>
            </div>

            <div className={styles.single}>
              <img
                src={this.state.minOneBigLetter ? SuccessIcon : ErrorIcon}
                alt="Icon"
              />
              <span>Hasło musi zawierać przynajmniej jedną dużą literę</span>
            </div>
          </div>

          {this.state.error && (
            <>
              <Alert severity="error">
                {this.state.error === "User already exists"
                  ? alreadyExistText
                  : this.state.error}
              </Alert>
              <br />
            </>
          )}

          <Button
            variant="contained"
            color="primary"
            className={styles.button}
            onClick={this.assignPassword}
            disabled={
              !password ||
              !password2 ||
              password !== password2 ||
              !this.state.minLength ||
              !this.state.minOneSmallLetter ||
              !this.state.minOneBigLetter ||
              !this.state.minOneNumber
            }
          >
            Przypisz hasło
          </Button>
        </form>
      </div>
    );
  }
}

CompleteAccountCreation.propTypes = {};

CompleteAccountCreation.defaultProps = {};

export default CompleteAccountCreation;
